import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export const useSessionData = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const sessionData = () => ({
    consumer: JSON.parse(window.sessionStorage.getItem('consumer')),
    aggregator: JSON.parse(window.sessionStorage.getItem('aggregator')),
    sessionId: window.sessionStorage.getItem('sessionId'),
    employeeIdMode: window.sessionStorage.getItem('employeeIdMode'),
    signupToken: window.sessionStorage.getItem('signupToken'),
    signinToken: window.sessionStorage.getItem('signinToken'),
    isLogin: window.sessionStorage.getItem('isLogin'),
    genericSignup: window.sessionStorage.getItem('genericSignup'),
    tos: window.sessionStorage.getItem('tos'),
    pp: window.sessionStorage.getItem('pp'),
    esign: window.sessionStorage.getItem('esign'),
    consent: window.sessionStorage.getItem('consent'),
    consentMessages: window.sessionStorage.getItem('consentMessages'),
    error: window.sessionStorage.getItem('error'),
    errorRetry:
      window.sessionStorage.getItem('errorRetry') === 'null'
        ? false
        : window.sessionStorage.getItem('errorRetry'),
    skippedLink: window.sessionStorage.getItem('skippedLink'),
    signupV2: window.sessionStorage.getItem('signupV2'),
    signupShortUrl: window.sessionStorage.getItem('signupShortUrl'),
  });

  const setSessionData = (key, value, saveInLocalStorage) => {
    window.sessionStorage.setItem(key, value);
    if (saveInLocalStorage) {
      window.localStorage.setItem(key, value);
    }
  };

  const gotoError = (error, retry = null) => {
    window.sessionStorage.setItem('error', error);
    window.sessionStorage.setItem('errorRetry', retry);
    navigate('/signup/error');
  };

  const verifySession = params => {
    const { checkConsumerFields, checkForSigninToken } = params || {};

    const {
      sessionId,
      employeeIdMode,
      genericSignup,
      signupToken,
      signinToken,
      aggregator,
      signupV2,
      consumer,
    } = sessionData();

    if (checkForSigninToken && signinToken === null) {
      const localStorageSigninToken = window.localStorage.getItem('signinToken');

      if (localStorageSigninToken) {
        setSessionData('signinToken', localStorageSigninToken);

        setSessionData('sessionId', sessionId || window.localStorage.getItem('sessionId'));

        return true;
      }

      const shortUrl = window.localStorage.getItem('signupShortUrl');

      gotoError(t('errors.session_expired'), `/${shortUrl}`);

      return false;
    }

    if (sessionId === null) {
      if (
        consumer === null ||
        (consumer !== null &&
          checkConsumerFields &&
          checkConsumerFields.some(
            field => consumer[field] === null || consumer[field] === undefined,
          )) ||
        [
          'sessionId',
          'employeeIdMode',
          'genericSignup',
          'signupToken',
          'aggregator',
          'signupV2',
        ].some(key => window.localStorage.getItem(key) === null)
      ) {
        const shortUrl = window.localStorage.getItem('signupShortUrl');

        gotoError(t('errors.session_expired'), `/${shortUrl}`);

        return false;
      }

      setSessionData('sessionId', sessionId || window.localStorage.getItem('sessionId'));
      setSessionData(
        'employeeIdMode',
        employeeIdMode || window.localStorage.getItem('employeeIdMode'),
      );
      setSessionData(
        'genericSignup',
        genericSignup || window.localStorage.getItem('genericSignup'),
      );
      setSessionData('signupToken', signupToken || window.localStorage.getItem('signupToken'));
      setSessionData(
        'aggregator',
        aggregator ? JSON.stringify(aggregator) : window.localStorage.getItem('aggregator'),
      );
      setSessionData('signupV2', signupV2 || window.localStorage.getItem('signupV2'));

      return true;
    }

    return true;
  };

  return { sessionData, setSessionData, verifySession, gotoError };
};
